var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { commonAttrs } from '../../utils';
import { CFToastContainerElements } from './ToastContainer.styles';
import { CFToast } from './Toast';
export const CFToastContainer = (_a) => {
    var { bottomOffset = 0, queue, visualLimit } = _a, rest = __rest(_a, ["bottomOffset", "queue", "visualLimit"]);
    const { Root } = CFToastContainerElements;
    return (React.createElement(Root, Object.assign({ bottomOffset: bottomOffset }, commonAttrs(rest)), queue.map((item, i) => {
        if (visualLimit && i >= visualLimit) {
            return null;
        }
        return React.createElement(CFToast, Object.assign({ key: `toast-item-${item.id || i}` }, item));
    })));
};
